import * as types from '../../constants/app/campaignConstants';

export const recommendedGameListRequest = ({
                                               page,
                                               pageLength,
                                               status,
                                               includePendingCampaigns,
                                               searchString,
                                               callback,
                                               error,
                                           }) => ({
    type: types.RECOMMENDED_GAME_LIST_REQUEST,
    page,
    pageLength,
    status,
    includePendingCampaigns,
    searchString,
    callback,
    error,
});

export const setRecommendedGameList = (list) => ({
    type: types.SET_RECOMMENDED_GAME_LIST,
    list,
});

export const recommendedGameDetailRequest = ({
                                                 campaignNo,
                                                 callback,
                                                 error,
                                             }) => ({
    type: types.RECOMMENDED_GAME_DETAIL_REQUEST,
    campaignNo,
    callback,
    error,
});

export const setRecommendedGameDetail = (info) => ({
    type: types.SET_RECOMMENDED_GAME_DETAIL,
    info,
});

export const recommendedGameRemoveRequest = (campaignNo) => ({
    type: types.RECOMMENDED_GAME_REMOVE,
    campaignNo,
});

export const recommendedGameCreateRequest = ({
                                                 campaignTitle,
                                                 startAt,
                                                 endAt,
                                                 appNo,
                                                 campaignLogoImage,
                                                 campaignDesc,
                                                 region,
                                                 needType,
                                                 needValue,
                                                 needMinNftGrade,
                                                 needMinNftLevel,
                                                 needNftType,
                                                 initialPerDeposited,
                                                 miningPerDayLimit,
                                                 usePowerDayLimit,
                                                 perOfBasicPower,
                                                 perBasicPower,
                                                 xperOfBasicPower,
                                                 x2eZone,
                                                 isAdvertised,
                                                 isEqualNftGrade,
                                                 plusFlag,
                                                 enableStartAt,
                                                 enableEndAt,
                                                 isBasicMode,
                                                 ticketId,
                                                 ticketCount,
                                                 callback,
                                                 error,
                                             }) => ({
    type: types.RECOMMENDED_GAME_CREATE,
    campaignTitle,
    startAt,
    endAt,
    appNo,
    campaignLogoImage,
    campaignDesc,
    region,
    needType,
    needValue,
    needMinNftGrade,
    needMinNftLevel,
    needNftType,
    initialPerDeposited,
    miningPerDayLimit,
    usePowerDayLimit,
    perOfBasicPower,
    perBasicPower,
    xperOfBasicPower,
    x2eZone,
    isAdvertised,
    isEqualNftGrade,
    plusFlag,
    enableStartAt,
    enableEndAt,
    isBasicMode,
    ticketId,
    ticketCount,
    callback,
    error,
});

export const recommendedGameLockStateUpdate = ({
                                                   campaignNo,
                                                   isLock,
                                                   callback,
                                                   error,
                                               }) => ({
    type: types.RECOMMENDED_GAME_LOCK_STATE_UPDATE,
    campaignNo,
    isLock,
    callback,
    error,
});

export const recommendedGameTerminateRequest = ({
                                                    campaignNo,
                                                    callback,
                                                    error,
                                                }) => ({
    type: types.RECOMMENDED_GAME_TERMINATE,
    campaignNo,
    callback,
    error,
});

export const specialGameListRequest = ({
                                           page,
                                           pageLength,
                                           status,
                                           includePendingCampaigns,
                                           searchString,
                                           callback,
                                           error,
                                       }) => ({
    type: types.SPECIAL_GAME_LIST_REQUEST,
    page,
    pageLength,
    status,
    includePendingCampaigns,
    searchString,
    callback,
    error,
});

export const setSpecialGameList = (list) => ({
    type: types.SET_SPECIAL_GAME_LIST,
    list,
});

export const specialGameDetailRequest = ({campaignNo, callback, error}) => ({
    type: types.SPECIAL_GAME_DETAIL_REQUEST,
    campaignNo,
    callback,
    error,
});

export const setSpecialGameDetail = (info) => ({
    type: types.SET_SPECIAL_GAME_DETAIL,
    info,
});

export const specialGameRemoveRequest = ({
                                             campaignNoArr,
                                             callback,
                                             error,
                                         }) => ({
    type: types.SPECIAL_GAME_REMOVE,
    campaignNoArr,
    callback,
    error,
});

export const specialGameCreateRequest = ({
                                             campaignTitle,
                                             startAt,
                                             endAt,
                                             appNo,
                                             campaignLogoImage,
                                             campaignDesc,
                                             region,
                                             needType,
                                             needValue,
                                             needMinNftGrade,
                                             needMinNftLevel,
                                             needNftType,
                                             initialPerDeposited,
                                             miningPerDayLimit,
                                             usePowerDayLimit,
                                             perOfBasicPower,
                                             perBasicPower,
                                             xperOfBasicPower,
                                             x2eZone,
                                             isAdvertised,
                                             isEqualNftGrade,
                                             plusFlag,
                                             enableStartAt,
                                             enableEndAt,
                                             ticketId,
                                             ticketCount,
                                             callback,
                                             error,
                                         }) => ({
    type: types.SPECIAL_GAME_CREATE,
    campaignTitle,
    startAt,
    endAt,
    appNo,
    campaignLogoImage,
    campaignDesc,
    region,
    needType,
    needValue,
    needMinNftGrade,
    needMinNftLevel,
    needNftType,
    initialPerDeposited,
    miningPerDayLimit,
    usePowerDayLimit,
    perOfBasicPower,
    perBasicPower,
    xperOfBasicPower,
    x2eZone,
    isAdvertised,
    isEqualNftGrade,
    plusFlag,
    enableStartAt,
    enableEndAt,
    ticketId,
    ticketCount,
    callback,
    error,
});

export const specialGameLockStateUpdate = ({
                                               campaignNo,
                                               isLock,
                                               callback,
                                               error,
                                           }) => ({
    type: types.SPECIAL_GAME_LOCK_STATE_UPDATE,
    campaignNo,
    isLock,
    callback,
    error,
});

export const specialGameTerminateRequest = ({
                                                campaignNo,
                                                callback,
                                                error,
                                            }) => ({
    type: types.SPECIAL_GAME_TERMINATE,
    campaignNo,
    callback,
    error,
});

export const campaignGameSortUpdate = ({
                                           gameCategory,
                                           list,
                                           callback,
                                           error,
                                       }) => ({
    type: types.CAMPAIGN_SORT_UPDATE,
    gameCategory,
    list,
    callback,
    error,
});

export const setCampaignPagination = (page, totalCount, searchString) => ({
    type: types.SET_CAMPAIGN_PAGINATION,
    page,
    totalCount,
    searchString,
});

export const campaignCheckPackageName = ({packageName, callback, error}) => ({
    type: types.CAMPAIGN_CHECK_PACKAGENAME,
    packageName,
    callback,
    error,
});

export const setCheckPackageNameResult = (data) => ({
    type: types.SET_CHECK_PACKAGENAME_RESULT,
    data,
});

export const setPagenation = (page, pageLength, totalCount, searchString) => ({
    type: types.SET_CAMPAIGN_PAGINATION,
    page,
    pageLength,
    totalCount,
    searchString,
});

export const setMessage = (message) => ({
    type: types.SET_MESSAGE_REQUEST,
    message,
});

export const setCampaignResponse = (resultCode) => ({
    type: types.SET_CAMPAIGN_RESPONSE,
    resultCode,
});

export const specialGameDepositRequest = ({
                                              campaignNo,
                                              transactionHash,
                                              callback,
                                              error,
                                          }) => ({
    type: types.SPECIAL_GAME_DEPOSIT_REQUEST,
    campaignNo,
    transactionHash,
    callback,
    error,
});

export const recommendedGameUpdateRequest = ({
                                                 // campaignNo,
                                                 // endAt,
                                                 // enableStartAt,
                                                 // enableEndAt,
                                                 // callback,
                                                 // error,
                                                 campaignNo,
                                                 campaignTitle,
                                                 startAt,
                                                 endAt,
                                                 appNo,
                                                 campaignLogoImage,
                                                 campaignDesc,
                                                 region,
                                                 needType,
                                                 needValue,
                                                 needMinNftGrade,
                                                 needMinNftLevel,
                                                 needNftType,
                                                 initialPerDeposited,
                                                 miningPerDayLimit,
                                                 usePowerDayLimit,
                                                 perOfBasicPower,
                                                 perBasicPower,
                                                 xperOfBasicPower,
                                                 x2eZone,
                                                 isAdvertised,
                                                 isEqualNftGrade,
                                                 plusFlag,
                                                 enableStartAt,
                                                 enableEndAt,
                                                 isBasicMode,
                                                 ticketId,
                                                 ticketCount,
                                                 callback,
                                                 error,
                                             }) => ({
    type: types.RECOMMENDED_GAME_UPDATE_REQUEST,
    // campaignNo,
    // endAt,
    // enableStartAt,
    // enableEndAt,
    // callback,
    // error,
    campaignNo,
    campaignTitle,
    startAt,
    endAt,
    appNo,
    campaignLogoImage,
    campaignDesc,
    region,
    needType,
    needValue,
    needMinNftGrade,
    needMinNftLevel,
    needNftType,
    initialPerDeposited,
    miningPerDayLimit,
    usePowerDayLimit,
    perOfBasicPower,
    perBasicPower,
    xperOfBasicPower,
    x2eZone,
    isAdvertised,
    isEqualNftGrade,
    plusFlag,
    enableStartAt,
    enableEndAt,
    isBasicMode,
    ticketId,
    ticketCount,
    callback,
    error,
});

export const specialGameUpdateRequest = ({
                                             // campaignNo,
                                             // endAt,
                                             // enableStartAt,
                                             // enableEndAt,
                                             // callback,
                                             // error,
                                             campaignNo,
                                             campaignTitle,
                                             startAt,
                                             endAt,
                                             appNo,
                                             campaignLogoImage,
                                             campaignDesc,
                                             region,
                                             needType,
                                             needValue,
                                             needMinNftGrade,
                                             needMinNftLevel,
                                             needNftType,
                                             initialPerDeposited,
                                             miningPerDayLimit,
                                             usePowerDayLimit,
                                             perOfBasicPower,
                                             perBasicPower,
                                             xperOfBasicPower,
                                             x2eZone,
                                             isAdvertised,
                                             isEqualNftGrade,
                                             plusFlag,
                                             enableStartAt,
                                             enableEndAt,
                                             ticketId,
                                             ticketCount,
                                             callback,
                                             error,

                                         }) => ({
    type: types.SPECIAL_GAME_UPDATE_REQUEST,
    // campaignNo,
    // endAt,
    // enableStartAt,
    // enableEndAt,
    // callback,
    // error,
    campaignNo,
    campaignTitle,
    startAt,
    endAt,
    appNo,
    campaignLogoImage,
    campaignDesc,
    region,
    needType,
    needValue,
    needMinNftGrade,
    needMinNftLevel,
    needNftType,
    initialPerDeposited,
    miningPerDayLimit,
    usePowerDayLimit,
    perOfBasicPower,
    perBasicPower,
    xperOfBasicPower,
    x2eZone,
    isAdvertised,
    isEqualNftGrade,
    plusFlag,
    enableStartAt,
    enableEndAt,
    ticketId,
    ticketCount,
    callback,
    error,
});
